import { render, staticRenderFns } from "./AppleSSOButton.vue?vue&type=template&id=521f9258&"
import script from "./AppleSSOButton.vue?vue&type=script&lang=js&"
export * from "./AppleSSOButton.vue?vue&type=script&lang=js&"
import style0 from "./AppleSSOButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports